export const VALIDATE_AUTH = data => {
  localStorage.removeItem('Token');
  localStorage.removeItem('auth');
  return {
    type: 'VALIDATE_AUTH',
    data,
  };
};

export const LOGIN = data => {
  localStorage.removeItem('Token');
  localStorage.setItem('auth', JSON.stringify(data));
  return {
    type: 'LOGIN',
    data,
  };
};

export const REFRESH_TOKEN = data => {
  localStorage.setItem('Token', data);
  const auth = localStorage.getItem('auth');
  if (auth) {
    localStorage.setItem('auth', JSON.stringify({ ...JSON.parse(auth), token: data }));
  }
  return {
    type: 'REFRESH_TOKEN',
    data,
  };
};
export const LOGOUT = () => {
  localStorage.clear();
  return { type: 'LOGOUT' };
};
